import { createStore } from './createStore.js';

/**
 * Small view-state that should survive reloads but isn't a user "setting":
 * e.g. which detail-page tab you last looked at.
 */
export const ui = createStore('pdx.ui', {
  detailTab: 'about',
  searchQuery: '',
  searchScroll: 0,
  searchTab: 'pokemon',
  feedScroll: 0,
  sort: 'dex',
  sortDesc: false,
  filter: 'all',
  filterType: '',
  filterGen: 0,
  filterAbility: 0,
  filterEggGroup: '',
  filterMinBst: 0,
  filterFullyEvolved: false,
  recent: [],
  compareIds: [],
  toolsOpen: false,
  teamMode: 'coverage',
  breedMode: 'groups',
  breedGroup: '',
  breedTarget: 0,
  mvType: '',
  mvClass: '',
  mvSort: 'name',
  mvTm: false,
  mvHm: false,
  itCat: '',
  itSort: 'name',
  abSort: 'name',
  progShowAll: false,
});
